// In-memory breadcrumbs attached to support tickets: the last routes visited
// and the last JS errors seen this session. Nothing is persisted or sent
// anywhere until the user files a ticket.

const MAX_ROUTES = 10;
const MAX_ERRORS = 5;
const MAX_ERROR_LENGTH = 300;

const routes: { path: string; at: number }[] = [];
const errors: { message: string; at: number }[] = [];
let listenersInstalled = false;

export const recordSupportRoute = (path: string) => {
  if (!path) return;
  const last = routes[routes.length - 1];
  if (last?.path === path) return;
  routes.push({ path, at: Date.now() });
  if (routes.length > MAX_ROUTES) routes.shift();
};

const recordSupportError = (message: string) => {
  if (!message) return;
  errors.push({
    message: message.slice(0, MAX_ERROR_LENGTH),
    at: Date.now(),
  });
  if (errors.length > MAX_ERRORS) errors.shift();
};

export const installSupportErrorListeners = () => {
  if (listenersInstalled || typeof window === "undefined") return;
  listenersInstalled = true;
  window.addEventListener("error", (event) => {
    recordSupportError(event.message || String(event.error ?? "Unknown error"));
  });
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    recordSupportError(
      reason instanceof Error ? reason.message : String(reason ?? "Unhandled rejection")
    );
  });
};

const minutesAgo = (at: number) => {
  const mins = Math.round((Date.now() - at) / 60000);
  return mins < 1 ? "just now" : `${mins}m ago`;
};

export const getSupportTrace = () => ({
  trail: routes.map((r) => `${r.path} (${minutesAgo(r.at)})`),
  recentErrors: errors.map((e) => `${e.message} (${minutesAgo(e.at)})`),
});
